import React from 'react';
import './Our_objective.css';
import Common_title from '../../common-components/common-title/Common_title';

const Our_objective = () => {
    return (
        <>
            <section className='Our_Objectives'>
                <div className='common_title_div'>
                    <Common_title title="OBJECTIVES" subtitle="Our Objectives" />
                </div>

                <div className='container'>
                    <div className='bg_img_holder'>
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/about-us/our-objective/fruits.png'}
                            className='bg_img'
                            alt="Fruits Background"
                        />

                        <div className='content_div'>
                            <div className='row'>
                                {/* Vision */}
                                <div className='col-md-6 mb-5'>
                                    <div className='white_card'>
                                        <div className='logo_img_holder'>
                                            <img
                                                src={process.env.PUBLIC_URL + '/assets/images/about-us/our-objective/vision.png'}
                                                className='logo_img'
                                                alt="Vision Icon"
                                            />
                                        </div>
                                        <p className='title'>Vision</p>
                                        <p className='dsecn'>
                                            Our vision is not just about selling vegetables. It’s about challenging what we have quietly accepted as “normal.”<br /><br />
                                            We’ve been taught that headaches, back pain, fatigue, and eye strain are just the price of a modern, professional life. We’ve accepted that our children might need glasses early, or that feeling truly energetic is a rare gift.<br /><br />
                                            I reject that reality completely.<br /><br />
                                            {/* My vision is to <strong>restore our natural state of being.</strong> It is to bring back the vibrant health that is our birthright.<br /><br />
                                            I see a future where our default state is wellness. Where a mother’s strength is a given, not a struggle. Where a child’s energy is a boundless force of nature. Where our professionals lead with clear minds and strong bodies, their potential fully unlocked.<br /><br />
                                            It is a future measured not by the absence of medical reports, but by the presence of effortless joy and vitality in our daily lives. We are not just aiming for a healthier India; we are building an India that has forgotten what it feels like to be unwell. */}
                                        </p>
                                    </div>
                                </div>

                                {/* Mission */}
                                <div className='col-md-6 mb-5'>
                                    <div className='white_card'>
                                        <div className='logo_img_holder'>
                                            <img
                                                src={process.env.PUBLIC_URL + '/assets/images/about-us/our-objective/mission.png'}
                                                className='logo_img'
                                                alt="Mission Icon"
                                            />
                                        </div>
                                        <p className='title'>Mission</p>
                                        <p className='dsecn'>
                                            To build that future, my team and I operate on a mission that is less of a business plan and more of a sacred protocol. It is our daily obsession.<br /><br />
                                            <strong>To Enforce a Protocol of Absolute Safety.</strong> My background is in healthcare, where you don’t hope for safety, you engineer it. Our mission is to apply that same rigorous discipline to your food. We will relentlessly eliminate every possible point of contamination, because trust isn’t an accident; it’s the result of a perfect process.<br /><br />
                                            {/* <strong>To Collapse the Time Between the Soil and the Table.</strong> We are at war with time. Every hour that passes, the life force in our food diminishes. Our mission is to create supply chains so rapid, and to gently pathway them from farm to your kitchen, ensuring the food we eat is not just fresh, but truly alive.<br /><br />
                                            <strong>To Absorb the Entire Burden of Food Trust.</strong> You have enough to manage in your life. It is not your job to worry about pesticides, hygiene, or supply chains. It is ours. Our mission is to take the entire weight of doubt and uncertainty off your shoulders, so you can experience the simple, profound joy of feeding your family with complete peace of mind.<br /><br />
                                            This is not just what we do. This is the code we live by. */}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Our_objective;
